import axios from "../../axios/axios-api";
import axiosCenso from "../../axios/axios-censo";

export const impedirLeito = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .put("/api/leitos/impedir", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};

export const selectsJustificativa = ({ commit }, payload) => {

    return axiosCenso
    .get("listarOpcaoImpedimento.php", payload)
    .then(resp => {
        if (resp.data.status == false) commit("setSelectsJustificativa", null)
        if (resp.data.status == true) commit("setSelectsJustificativa", resp.data.dados)
    })
    .catch(error => {
        console.error(error);
    });

};